import { render, staticRenderFns } from "./OrdiniListPage.vue?vue&type=template&id=0d5e48f9"
import script from "./OrdiniListPage.vue?vue&type=script&lang=js"
export * from "./OrdiniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports